/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

import _ from "underscore";
import eventEmitterMixin from "../mixins/event-emitter";

export default _.extend({}, eventEmitterMixin);

